import env from "react-dotenv";
export const CONF_AUTH = {
    AUTH_SERVER_HOST: process.env.REACT_APP_URL_AUTH_BE, // Server Production
    // AUTH_SERVER_HOST: "https://k8s-auth.eduprime.co.id", // Server Production
    //    AUTH_SERVER_HOST: 'https://k8s-auth-staging.eduprime.co.id', // Server Localhost
    //  AUTH_SERVER_HOST: 'http://13.251.196.184:8001', // Server Localhost

    AUTH_LOGIN: "/oauth/token",
};
